'use strict'

import Swiper from 'swiper'

export default class SwiperComponent {
  enable () {
    if (document.querySelector('.mySwiper')) {
      const swiper = new Swiper('.mySwiper', {
        spaceBetween: 5,
        slidesPerView: 3,
        centeredSlides: true,
        initialSlide: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        loop: true
      })
    }
  }
}
